/**
 * Lives here (not in pages/api-console) so the legacy breadcrumb builder
 * (src/common/, which may not import from pages/) can read the same values.
 */
export enum ApiConsoleTab {
  Overview = "overview",
  Accounts = "accounts",
  Invitations = "invitations",
}

export const API_CONSOLE_TAB_ORDER: ApiConsoleTab[] = [
  ApiConsoleTab.Overview,
  ApiConsoleTab.Accounts,
  ApiConsoleTab.Invitations,
];

export const isApiConsoleTab = (value: string | null): value is ApiConsoleTab =>
  API_CONSOLE_TAB_ORDER.some((tab) => tab === value);
